export const credoresGazin = [217, 434, 620, 674, 718, 720, 2002];
